var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  var objToString = Object.prototype.toString,
      isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);

  exports = function (value) {
    return typeof value === "function" && isFunctionStringTag(objToString.call(value));
  };

  return exports;
}